import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Appliances from '../Components/Appliances/Appliances'
import Electronics from '../Components/Electronics/Electronics'
import Fitness from '../Components/Fitness/Fitness'
import Furniture from '../Components/Furniture/Furniture'
import Packages from '../Components/Packages/Packages'
import Delhi from '../Pages/Delhi'
import Home from '../Pages/Home'

const AllRoutes = () => {
  return (
    <div>
        <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/delhi" element={<Delhi />} />
        <Route path="/delhi/packages" element={<Packages />} />
        <Route path="/delhi/furniture" element={<Furniture />} />
        <Route path="/delhi/appliances" element={<Appliances />} />
        <Route path="/delhi/electronics" element={<Electronics />} />
        <Route path="/delhi/fitness" element={<Fitness />} />
      </Routes>
    </div>
  )
}

export default AllRoutes